export default __webpack_public_path__ + "static/media/sidebar-11.cfb03609.png";